<div class="campaign-preview-button-wrapper" [ngClass]="classComponent">
  <div>
    @if (data.widgets && data.widgets.length === 1) {
      <div>
        <!-- Wrap in div for layout consistency if needed, but span is for tooltip -->
        <span [matTooltip]="!hasValidStep(data.widgets[0]) ? ('campaign.publish-validation.no-valid-steps' | translate) : ''">
          <button
            mat-stroked-button
            [class.gray-button]="!fillBackground"
            [class.primary-button]="fillBackground"
            [disabled]="!hasValidStep(data.widgets[0])"
            (click)="previewWidget(data.widgets[0])">
            <span class="btn-label">
              <mat-icon>open_in_new</mat-icon>
              {{ previewLabel | translate | uppercase }}
            </span>
          </button>
        </span>
      </div>
    }
    @if (data.widgets && data.widgets.length > 1) {
      <div>
        <button [class.gray-button]="!fillBackground" [class.primary-button]="fillBackground" mat-stroked-button [matMenuTriggerFor]="clickMenu">
          <span class="btn-label">
            <mat-icon>open_in_new</mat-icon>
            {{ previewLabel | translate | uppercase }}
          </span>
        </button>
      </div>
      <mat-menu #clickMenu="matMenu">
        <app-variant-widget [data]="data" (previewWidget)="previewWidget($event)"></app-variant-widget>
      </mat-menu>
    }
  </div>
</div>
